import DOMPurify from 'dompurify';

export const getDaysOfWeek = (item) => {
    if (!item) return '';
    const map = {
        monDay: 'Mon', tueDay: 'Tue', wedDay: 'Wed',
        thuDay: 'Thu', friDay: 'Fri', satDay: 'Sat', sunDay: 'Sun'
    };
    return Object.entries(map)
        .filter(([key]) => item[key] && String(item[key]).trim() !== "")
        .map(([, label]) => label)
        .join(', ');
};

export const formatTime = (time) => {
    if (!time || String(time).length !== 4) return time;
    const timeStr = String(time);
    const hours = parseInt(timeStr.slice(0, 2), 10);
    const minutes = timeStr.slice(2);
    if (isNaN(hours)) return time;
    const period = hours >= 12 ? 'PM' : 'AM';
    const standardHour = hours % 12 || 12;
    return `${standardHour}:${minutes} ${period}`;
};

export const formatDateRange = (start, end) => {
    const format = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        return isNaN(date.getTime()) ? '' : date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };
    const formattedStart = format(start);
    const formattedEnd = format(end);
    if (formattedStart && formattedEnd) {
        return `${formattedStart} - ${formattedEnd}`;
    } else if (formattedStart) {
        return formattedStart;
    } else if (formattedEnd) {
        return formattedEnd;
    }
    return 'N/A';
};

export const formatDateRangeDuration = (start, end) => {
    const format = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        return isNaN(date.getTime()) ? '' : date.toLocaleDateString('en-US', {
            month: 'numeric',
            year: '2-digit',
            day: 'numeric'
        });
    };
    const formattedStart = format(start);
    const formattedEnd = format(end);
    if (formattedStart && formattedEnd) {
        return `${formattedStart} - ${formattedEnd}`;
    } else if (formattedStart) {
        return formattedStart;
    } else if (formattedEnd) {
        return formattedEnd;
    }
    return 'N/A';
};

export const createMarkup = (html) => {
    if (!html) return { __html: '' };
    const cleanHtml = DOMPurify.sanitize(html, {
        ADD_ATTR: ['target', 'rel', 'style'],
        RETURN_DOM: true
    });
    const anchors = cleanHtml.querySelectorAll('a');
    anchors.forEach(a => {
        a.setAttribute('target', '_blank');
        a.setAttribute('rel', 'noopener noreferrer');
        a.style.color = '#2563eb';
        a.style.textDecoration = 'underline';
        a.classList.add('text-blue-600', 'hover:underline');
    });
    return { __html: cleanHtml.innerHTML };
};

export const getCriticalDatesForItem = (item) => {
    if (!item) {
        return [];
    }

    return [
        {
            label: "Last day to add class",
            value: formatDateRange(item.lastDateToEnroll)
        },
        {
            label: "Last day to drop with a refund",
            value: formatDateRange(item.refundDate)
        },
        {
            label: "Census Date",

            value: formatDateRange(item.censusDate)
        },
        {
            label: "Last day to declare grade mode",
            value: formatDateRange(item.grademodeDate)
        },
        {
            label: "Last day to drop without a \"W\"",
            value: formatDateRange(item.dropNoWDate)
        },
        {
            label: "Last day to drop with a \"W\"",
            value: formatDateRange(item.dropWDate)
        }
    ];
};